import React from "react";

// Funcao para formatar data do Pedido:

export default function getFormatData (data) {
	// Aqui, separamos em strings onde possui o caracter -, obtendo ("YYYY", "MM", "DD")
	//    Depois revertemos a ordem, obtendo ("DD", "MM", "YYYY") e depois juntamos as strings adicionando /
	data = data.split('-').reverse().join('/');
	return data
}